import { SavedSearchesApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function useSavedSearchesAPI(): SavedSearchesApi {
  return new SavedSearchesApi(apiConfig);
}
